import { useRef, useState } from "preact/hooks";
import "./FileDropZone.css";

export function FileDropZone({
  accept = "",
  label,
  note = "",
  onFileSelected
}) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  function selectFile(file) {
    if (!file) {
      return;
    }

    onFileSelected?.(file);
  }

  function openPicker() {
    inputRef.current?.click();
  }

  return (
    <div
      class={`file-drop-zone${dragActive ? " active" : ""}`}
      onClick={openPicker}
      onDragEnter={(event) => {
        event.preventDefault();
        setDragActive(true);
      }}
      onDragOver={(event) => {
        event.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={(event) => {
        event.preventDefault();

        if (!event.currentTarget.contains(event.relatedTarget)) {
          setDragActive(false);
        }
      }}
      onDrop={(event) => {
        event.preventDefault();
        setDragActive(false);
        selectFile(event.dataTransfer?.files?.[0] ?? null);
      }}
    >
      <input
        ref={inputRef}
        class="file-drop-zone-input"
        type="file"
        accept={accept}
        onChange={(event) => {
          selectFile(event.currentTarget.files?.[0] ?? null);
          event.currentTarget.value = "";
        }}
      />

      <div class="file-drop-zone-copy">
        <p class="file-drop-zone-label">{label}</p>
        {note ? <p class="file-drop-zone-note">{note}</p> : null}
      </div>
    </div>
  );
}
